import {GenRestorationCurve} from '../../generated/serverModels/GenRestorationCurve';

export class RestorationPoint extends GenRestorationCurve{
  constructor(curve?: RestorationPoint) {
    super(curve);
  }
}
